<template>

    <div class="garant-history-list" v-if="history">

        <div class="garant-history-list__item" v-for="item of history">

            <div class="garant-history-list__row">
                <div class="garant-history-list__col garant-history-list__label">
                    Статус
                </div>
                <div class="garant-history-list__col garant-history-list__item-status">
                    {{item.status}}
                    <div v-if="item.declined">В гарантии отказано</div>
                </div>
            </div>

            <div class="garant-history-list__row" v-if="item.managerComment">
                <div class="garant-history-list__col garant-history-list__label">
                    Комментарий<br/> менеджера
                </div>
                <div class="garant-history-list__col garant-history-list__item-name">{{item.managerComment}}</div>
            </div>
            <div class="garant-history-list__row" v-if="item.managerPhoto">
                <div class="garant-history-list__col garant-history-list__label">
                </div>
                <div class="garant-history-list__col garant-history-list__item-name" v-for="photo of item.managerPhoto">
                    <img class="garant-history-list__img" :src="photo"/>
                </div>
            </div>


            <div class="garant-history-list__row">
                <div class="garant-history-list__col garant-history-list__label">
                    Номер заявки
                </div>
                <div class="garant-history-list__col garant-history-list__item-number">
                    {{item.id}}
                </div>
            </div>


            <div class="garant-history-list__row">
                <div class="garant-history-list__col garant-history-list__label">
                    Товар
                </div>
                <div class="garant-history-list__col garant-history-list__item-name">
                    {{item.name}}
                </div>
            </div>


            <div class="garant-history-list__row">
                <div class="garant-history-list__col garant-history-list__label">
                    Номер заказа
                </div>
                <div class="garant-history-list__col garant-history-list__item-name">
                    {{item.orderNumber}}
                </div>
            </div>

            <div class="garant-history-list__row">
                <div class="garant-history-list__col garant-history-list__label">
                    Способ зачета
                </div>
                <div class="garant-history-list__col garant-history-list__item-variant">
                    {{item.setOfVariant}}
                </div>
            </div>

            <div class="garant-history-list__row">
                <div class="garant-history-list__col garant-history-list__label">
                    Акт рекламации
                </div>

                <div class="garant-history-list__col">
                    <a :href="item.actOfReclamation"
                       target="_blank">aitech_{{item.id}}.pdf</a><br>
                    <a :href="item.actHtmlReclamation"
                       target="_blank">aitech_{{item.id}}.html</a>
                </div>
            </div>

            <div class="garant-history-list__row">
                <div class="garant-history-list__col garant-history-list__label">
                    Трек номер
                </div>
                <div class="garant-history-list__col garant-history-list__track-number-wrap">
                    <input class="user-track-number" type="text"
                           :value="item.trackNumber"
                           @input="setTrackNumber(item.id, $event.target.value)"
                    >
                </div>
                <div class="garant-history-list__col garant-history-list__col-desc">
                    Номер, который вы получили на почте или в транспортной компании.<br/>
                    С ним мы быстрее сможем обработать вашу заявку.
                </div>
            </div>

            <div class="garant-history-list__row" v-if="item.trackNumberBack">
                <div class="garant-history-list__col garant-history-list__label ">
                    Трек номер посылки<br> для вас
                </div>
                <div class="garant-history-list__col garant-history-list__track-number-wrap">
                    <div class="garant-history-list__track-number">
                        {{item.trackNumberBack}}
                    </div>
                </div>
                <div class="garant-history-list__col garant-history-list__col-desc">
                    Мы отправили вам посылку, отслеживайте ее статус по этому номеру
                </div>
            </div>
        </div>
    </div>
    <div v-else>
        <h1>Пока ни одной заявки</h1>
        <a href="#" @click="$event.preventDefault(); $store.commit('setTab', 'return')">Добавить</a>
    </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'return-history',
    created () {
      this.$store.dispatch('return/fetchHistory')
    },
    computed: {
      ...mapGetters('return', [
        'history'
      ])
    },
    methods: {
      setTrackNumber (id, trackNumber) {
        this.$store.dispatch('return/setTrackNumber', {id, trackNumber})
      }
    }
  }
</script>

<style lang="scss" scoped>
    .defect-button {
        font-size: 11px;
        display: inline-block !important;
        vertical-align: top !important;
        width: 140px;
        height: 20px;
        margin-left: 20px;
        border: 0;
        text-align: center;
        text-decoration: none;
        line-height: 20px;
        border-radius: 3px;
        cursor: pointer;
        color: #fff;
        background: #6EAD6D;
        &:hover {
            color: #fff;
        }
    }

    .garant-history-list {
        font-size: 12px;
        margin-top: 20px;
    }

    .garant-history-list__row {
        margin-bottom: 10px;
    }

    .garant-history-list__item {
        margin-bottom: 20px;
        padding: 20px;
        border-radius: 15px;
        border: 2px dashed #dedede;
    }

    .garant-history-list__col {
        display: inline-block;
        vertical-align: top;
    }

    .garant-history-list__col-desc {
        width: 420px;
        padding-left: 5px;
        opacity: 0.8;
    }

    .garant-history-list__label {
        display: inline-block;
        vertical-align: top;
        width: 150px;
    }

    .garant-history-list__item-number {
        font-size: 22px;
    }

    .garant-history-list__item-name {
    }

    .garant-history-list__item-status {
        width: 200px;
    }

    .garant-history-list__item-variant {
        width: 100px;
    }

    .garant-history-list__item-order-number {
        width: 50px;
    }

    .garant-history-list__item-track-number {
        width: 200px;
    }

    .garant-history-list__item-track-number2 {
        width: 100px;
    }

    .garant-history-list__img {
        display: inline-block;
        vertical-align: top;
        margin: 0 5px 5px 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/Personal/Return/ReturnHistory.vue